import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getRulesFromState, get, haveRulesChanged } from 'ctm-util-functions';
import { resultsConfigSelector } from 'ctm-selectors';

import { onChange } from '../utils';
import { Select } from '../../form/select/select';
import { SimpleFlexbox } from '../../flexbox/flexbox';
import { Text } from '../../text/text';
import { getSimpleLabel } from '../../utils';

class _SelectFilter extends Component {

    constructor(props) {
        super(props);
        this.label = getSimpleLabel(props);
        this.schema = this.getSchema();
    }

    /**
     * Return the schema for the Select to use as the filter
     * @returns {Object} - The schema for the Select used as the filter
     */
    getSchema = () => {
        const { filterProps } = this.props;
        const { formStateKey, options } = filterProps;

        if (!options) {
            return null;
        }

        return {
            label: this.label,
            field: {
                type: 'select',
                UIComponent: 'select_auto',
                options
            },
            identifier: `helpers.filters.${formStateKey}`,
            stateKey: 'vertical.quote'
        };
    };

    /**
     * Determine if the component should re-render based on the nextState
     * @param  {Object} nextProps  The incoming set of props
     * @returns {Boolean} true if the component should re-render
     */
    shouldComponentUpdate = (nextProps) => {
        const { selectedValue, rules } = this.props;
        return (selectedValue !== nextProps.selectedValue) || (rules && haveRulesChanged(nextProps, this.props));
    };

    /**
     * Render the select component.
     * This is a wrapper for the moment, as a way to keep the results form schemas together.
     * This may be refactored in future to just use quote form schema, when it is more powerful.
     * @returns {Node} The select menu.
     */
    render = () => {
        const { rules, selectedValue, dispatch } = this.props;
        if (!get(rules, 'visibility.result', true)) {
            return null;
        }

        return (
            <SimpleFlexbox display="flex" column flex={1} margin="right_small">
                <Text size="large" color="brand_base_120" variant="white_space_nowrap" label={this.label} />
                <Select schema={this.schema}
                    onChange={(e) => { return onChange(e, this.props); }}
                    value={selectedValue || null}
                    dispatch={dispatch}
                    ignoreSetValue
                    rules={rules}
                />
            </SimpleFlexbox>
        );
    };

}

_SelectFilter.propTypes = {
    filterProps: PropTypes.shape({
        filter: PropTypes.string,
        label: PropTypes.string,
        showUpdateButton: PropTypes.bool,
        fetchNewResults: PropTypes.bool.isRequired,
        formStateKey: PropTypes.string.isRequired,
        resultsStateKey: PropTypes.string.isRequired,
        resultsStagedStateKey: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string,
                label: PropTypes.string,
                default: PropTypes.bool
            })
        ).isRequired
    }).isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    contentProps: PropTypes.shape({
        label: PropTypes.string.isRequired,
        selectors: PropTypes.object
    }),
    rules: PropTypes.object,
    selectedValue: PropTypes.string,
    dispatch: PropTypes.func
};

/**
 * mapStateToProps - sets up the rules required by this component
 * @param {Object} state - The entire application state
 * @param {Object} props - The props for the form group this is being applied to
 * @returns {Object}     - Props for the component, mapped from state values
 */
const mapStateToProps = (state, props) => {
    const rules = getRulesFromState(state, props);
    const selectedValue = resultsConfigSelector(state).getIn(props.filterProps.resultsStagedStateKey.split('.'));
    return {
        selectedValue,
        rules
    };
};

export { _SelectFilter };
export const SelectFilter = connect(mapStateToProps)(_SelectFilter);
